import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { Select } from 'antd'
import i18next from 'i18next'

import 'moment/locale/pl'

export const availableLanguages = [
    {
        label: 'PL',
        value: 'pl',
    },
    {
        label: 'EN',
        value: 'en',
    },
]

const SelectLanguage: FC = () => {
    const { i18n, t } = useTranslation()

    const handleLanguageChange = (languageKey: string) => {
        i18next.changeLanguage(languageKey)
    }

    return (
        <>
            <Helmet>
                <html lang={i18n.language} />
            </Helmet>
            <Select
                defaultValue={i18n.language}
                options={availableLanguages}
                onSelect={handleLanguageChange}
                size="small"
                aria-label={t('change_site_language')}
                defaultOpen={false}
            />
        </>
    )
}
export default SelectLanguage
